const data = [
    { id: 1, name: "Entrada" },
    { id: 2, name: "Saída" },
    { id: 3, name: "Ambos" },
]

export default [...data]